// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  overflow: hidden;
  text-decoration: none;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* index.css */
body, html {
  margin: 0;
  padding: 0;
  overflow: hidden; /* Prevent scrolling */
  width: 100%;
  height: 100%;
  position: absolute;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .page{
    width: 100%;
    height: 100%;
    position: relative;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}


canvas {
  height: 100vh;
  width: 100vw;
  display: block;
}

/* From Uiverse.io by mrhyddenn */ 
.scrolldown {
  position: absolute;
  width: 100px;
  height: 100px;
  border: calc(50px / 10) solid transparent;
  box-sizing: border-box;
  margin-bottom: 16px;
  cursor: pointer;
  z-index: 99;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: transparent;
}

@keyframes scrolldown-anim {
  0% {
    opacity: 0;
    height: 6px;
  }

  40% {
    opacity: 1;
    height: 10px;
  }

  80% {
    transform: translate(0, 20px);
    height: 10px;
    opacity: 0;
  }

  100% {
    height: 3px;
    opacity: 0;
  }
}

.chevrons {
  padding-top: 20px;
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
}

.chevrondown {
  margin-top: -6px;
  position: relative;
  border: solid black;
  border-width: 0 10px 10px 0;
  display: inline-block;
  width: 50px;
  height: 50px;
  transform: rotate(-135deg);
}

.chevrondown:nth-child(even) {
  animation: pulse54012 1000ms ease infinite alternate;
}

.chevrondown:nth-child(odd) {
  animation: pulse54012 1000ms ease infinite alternate 500ms;
}

@keyframes pulse54012 {
  from {
    opacity: 0;
  }

  to {
    opacity: 0.4;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,cAAc;AACd;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,sBAAsB;EACxC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  outline: none;\n  overflow: hidden;\n  text-decoration: none;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* index.css */\nbody, html {\n  margin: 0;\n  padding: 0;\n  overflow: hidden; /* Prevent scrolling */\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  .page{\n    width: 100%;\n    height: 100%;\n    position: relative;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n\n\ncanvas {\n  height: 100vh;\n  width: 100vw;\n  display: block;\n}\n\n/* From Uiverse.io by mrhyddenn */ \n.scrolldown {\n  position: absolute;\n  width: 100px;\n  height: 100px;\n  border: calc(50px / 10) solid transparent;\n  box-sizing: border-box;\n  margin-bottom: 16px;\n  cursor: pointer;\n  z-index: 99;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: transparent;\n}\n\n@keyframes scrolldown-anim {\n  0% {\n    opacity: 0;\n    height: 6px;\n  }\n\n  40% {\n    opacity: 1;\n    height: 10px;\n  }\n\n  80% {\n    transform: translate(0, 20px);\n    height: 10px;\n    opacity: 0;\n  }\n\n  100% {\n    height: 3px;\n    opacity: 0;\n  }\n}\n\n.chevrons {\n  padding-top: 20px;\n  width: 100%;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: transparent;\n}\n\n.chevrondown {\n  margin-top: -6px;\n  position: relative;\n  border: solid black;\n  border-width: 0 10px 10px 0;\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  transform: rotate(-135deg);\n}\n\n.chevrondown:nth-child(even) {\n  animation: pulse54012 1000ms ease infinite alternate;\n}\n\n.chevrondown:nth-child(odd) {\n  animation: pulse54012 1000ms ease infinite alternate 500ms;\n}\n\n@keyframes pulse54012 {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 0.4;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
